export default "__VITE_ASSET__B0r$cXpV__"